import React, { useContext, useEffect, useState } from "react";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { AppContext } from "../../util/context";
import { StepField } from "./Step.types";
import StepFooter from "./StepFooter";
import StepForm from "./StepForm";
import StepHeading from "./StepHeading";
import StepPage from "./StepPage";
import StepQuestion from "./StepQuestion";
import block from 'bem-css-modules';
import styles from "./Step.module.scss";

const Step = (props: { stepData: StepField, stepIndex: number }) => {
  const context = useContext(AppContext);
  const { settings: { backButton }, activeStepIndex, handleBackClick } = context;
  const {
    stepData,
    stepIndex,
  } = props;

  const [backButtonActive, setBackButtonActive] = useState(false);

  const b = block(styles);
  const stepSettings = stepData.stepSettings[0];
  const stepHeader = stepData.stepHeader[0];
  const stepFooter = stepData.stepFooter[0];
  const { _modelApiKey, isSuccessPage = false, activateRecaptcha } = stepData;

  useEffect(() => {
    const isBackButtonActive = backButton &&
                    stepIndex > 0 &&
                    !isSuccessPage
                    ? true : false;
    setBackButtonActive(isBackButtonActive);
  }, [backButton, backButtonActive, activeStepIndex]);

  return (
    <div className={`fc-step ${b()} ${stepSettings?.classes} ${activeStepIndex === stepIndex ? styles['is-active'] : ''}`} >
      {backButtonActive && (
        <div className={`fc-back-button ${b("back")}`} onClick={() => handleBackClick(context)}>
          <span className={b("arrow")}>➔</span> <span dangerouslySetInnerHTML={{__html: backButton}}/>
        </div>
      )}
      {(stepHeader.title || stepHeader.subtitle || stepHeader.description) && (
        <StepHeading type={_modelApiKey} title={stepHeader.title} subtitle={stepHeader.subtitle} description={stepHeader.description} />
      )}
      <div className={`fc-step-body ${b("body")}`}>
        {(() => {
          switch (_modelApiKey) {
            case "step_form":
              return activateRecaptcha ? (
                <GoogleReCaptchaProvider reCaptchaKey="6LebQA4rAAAAAHg-1je20Qk-tfMKzcjz_ZvGHhsM">
                  <StepForm stepData={stepData} />
                </GoogleReCaptchaProvider>
              ) : (
                <StepForm stepData={stepData} />
              );
            case "step_question":
              return <StepQuestion stepData={stepData} activeStepIndex={activeStepIndex} stepIndex={stepIndex} />
            case "step_page":
              return <StepPage stepData={stepData} activeStepIndex={activeStepIndex} stepIndex={stepIndex} />
              
          }
        })()}
      </div>
      { stepFooter &&
        <StepFooter text={stepFooter.text} />
      }
    </div>
  )
}

export default Step;